import { Action, createReducer, on } from '@ngrx/store';
import { AccountSettingsState } from './account-settings.state';
import {
  getNotificationsAction,
  getNotificationsErrorAction,
  getNotificationsSuccessAction,
  getSurvaysAction,
  getSurvaysErrorAction,
  getSurvaysSuccessAction,
} from './account-settings.actions';

const initialState = new AccountSettingsState();

const reducer = createReducer(
  initialState,
  on(getSurvaysAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getSurvaysSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.survays = payload.survays;
    return newState;
  }),
  on(getSurvaysErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),

  on(getNotificationsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getNotificationsSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.notifications = payload.notifications;
    return newState;
  }),
  on(getNotificationsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  })

  // on(ClearStateAction, (state, payload) => {
  //   const newState = { ...state };
  //   switch(payload.actionType) {
  //     case 'locationMenus':
  //       newState.locationMenus = null;
  //     break;
  //     default:
  //       break;
  //   }
  //   newState.isLoading = false;
  //   newState.failures = null;
  //   return newState;
  // }),
);

export function AccountSettingsReducer(state: AccountSettingsState | null, action: Action) {
  return reducer(state, action);
}
